import { IconButton, Typography, useTheme } from '@mui/material';
import i18next from 'i18next';
import { memo, useCallback } from 'react';

import { MultiStoreDot } from './multi-store-dot';

interface MultiStoreDayProps {
  date: string;
  dayOfWeek: number;
  dayOfMonth: number;
  isActive: boolean;
  isSelected: boolean;
  // libero solo negli altri centri inclusi: puntino sotto il numero
  isElsewhereOnly: boolean;
  onSelect: (date: string) => void;
}

// Giorno della settimana col cerchio del DateContainer del WeekPicker. Sfondo e colore del
// giorno scelto stanno sul contenitore (non sull'IconButton del tema), che il bottone eredita.
export const MultiStoreDay = memo(function MultiStoreDay({
  date,
  dayOfWeek,
  dayOfMonth,
  isActive,
  isSelected,
  isElsewhereOnly,
  onSelect,
}: MultiStoreDayProps): JSX.Element {
  const { palette } = useTheme();
  const dayLabel = i18next.t(`subDaysOfWeek.${dayOfWeek}`);

  const handleClick = useCallback(() => {
    onSelect(date);
  }, [date, onSelect]);

  let color: string | undefined;
  if (isSelected) color = palette.primary.contrastText;
  else if (isActive) color = palette.text.primary;

  return (
    <div
      className="multi-store-day"
      style={{
        backgroundColor: isSelected ? palette.primary.main : undefined,
        color,
      }}
    >
      <IconButton
        color="inherit"
        disabled={!isActive}
        className="date-container"
        aria-pressed={isSelected}
        aria-label={
          isElsewhereOnly
            ? `${dayLabel} ${dayOfMonth}, ${i18next.t(
                'pages.when.multi_store.elsewhere_only'
              )}`
            : undefined
        }
        onClick={handleClick}
      >
        <Typography variant="body2" component="span">
          {dayLabel}
        </Typography>
        <Typography variant="body1" component="span">
          <b>{dayOfMonth}</b>
        </Typography>
        {isElsewhereOnly && (
          <MultiStoreDot isInverted={isSelected} className="multi-store-day-dot" />
        )}
      </IconButton>
    </div>
  );
});
